import { useStoreData } from './useStoreData';
import { useAppSelector } from '@/store';
import { selectStoreId, selectAvailableStores } from '@/store/slices/authSlice';

/**
 * Convenience hook to determine whether the current store is a Shopify store
 * or a standalone (custom) store.
 *
 * Reads from `useStoreData()` first, falling back to `availableContexts.stores`
 * in Redux for the current `storeId`.
 */
export const useIsShopifyStore = () => {
    const { data: storeData, isLoading } = useStoreData();
    const currentStoreId = useAppSelector(selectStoreId);
    const availableStores = useAppSelector(selectAvailableStores);

    // Primary source: store details API response
    let platform = storeData?.store?.platform;

    // Fallback: check availableContexts.stores from /auth/me
    if (!platform && currentStoreId) {
        const matchedStore = availableStores.find((s) => s.storeId === currentStoreId);
        platform = matchedStore?.platform;
    }



    return {
        platform: platform ?? null,
        isShopifyStore: platform === 'shopify',
        isStandaloneStore: platform === 'custom',
        isLoading,
    };
};
